<template>
  <nav v-if="totalPages > 1" aria-label="Page navigation">
    <ul class="pagination justify-content-center my-3">
      <!-- Кнопка «Назад» -->
      <li class="page-item" :class="{ disabled: currentPage === 1 }">
        <button class="page-link" @click="goTo(currentPage - 1)" :disabled="currentPage === 1">
          &laquo;
        </button>
      </li>

      <!-- Список видимых страниц -->
      <li
          v-for="page in visiblePages"
          :key="page"
          class="page-item"
          :class="{ active: page === currentPage }"
      >
        <button class="page-link" @click="goTo(page)">
          {{ page }}
        </button>
      </li>

      <!-- Кнопка «Вперёд» -->
      <li class="page-item" :class="{ disabled: currentPage === totalPages }">
        <button class="page-link" @click="goTo(currentPage + 1)" :disabled="currentPage === totalPages">
          &raquo;
        </button>
      </li>
    </ul>
  </nav>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  modelValue: { type: Number, required: true },
  totalPages: { type: Number, required: true },
  maxVisible: { type: Number, default: 5 },
})

const emit = defineEmits(['update:modelValue'])

const currentPage = computed(() => props.modelValue)

function goTo(page) {
  if (page >= 1 && page <= props.totalPages) {
    emit('update:modelValue', page)
  }
}

const visiblePages = computed(() => {
  const half = Math.floor(props.maxVisible / 2)
  let start = Math.max(currentPage.value - half, 1)
  let end = start + props.maxVisible - 1

  if (end > props.totalPages) {
    end = props.totalPages
    start = Math.max(end - props.maxVisible + 1, 1)
  }

  return Array.from({ length: end - start + 1 }, (_, i) => start + i)
})
</script>
<style scoped>
  .page-link {
    color: #034c48;
  }
  .page-item:last-child .page-link {
    color: #034c48;
  }
  .page-item:not(:first-child) .page-link {
    color: #034c48;
  }
  .page-item.active:not(:first-child) .page-link {
    color: #fff;
    background:#034c48;
  }
  .page-link:focus {
    box-shadow: 0 0 0 0.25rem rgba(66, 185, 131, 0.25);
  }
</style>